export default theme => ({
  iconButton: {
    padding: 9,
  },
  title: {
    fontWeight: 500,
  },
});
